import type { RouteRecordRaw } from 'vue-router'
import router from '@/router'
import ChangeLayout from '@/views/dashboard/show_settings/ChangeLayout.vue'
import EditList from '@/views/dashboard/show_settings/EditList.vue'
import { createShowSettings } from '@/views/dashboard/show_settings/ShowSettings.vue'
import ShowSettings from '@/views/dashboard/show_settings/ShowSettings.vue'
import SortAccount from '@/views/dashboard/show_settings/SortAccounts.vue'

const showSettingRoutes = [
  {
    name: 'ShowSettings',
    component: ShowSettings,
  },
  {
    name: 'ChangeLayout',
    component: ChangeLayout,
  },
  {
    name: 'SortAccounts',
    component: SortAccount,
  },
  {
    name: 'EditList',
    component: EditList,
  },
]

export const selectShowSettingRoute = (params: {
  name: string
  rootName?: string
  path?: string
  onSelectRoute: (name: string) => void
}): RouteRecordRaw => {
  return {
    name: params.name,
    path: params.path ?? 'setting',
    component: createShowSettings(
      params.onSelectRoute,
      getName('ChangeLayout', params.rootName),
      getName('EditList', params.rootName),
    ),
    props: true,
  }
}
export const walletShowSettingRoute = (rootName?: string) => {
  return selectShowSettingRoute({
    name: getName('showSetting', rootName),
    rootName: rootName,
    onSelectRoute(name) {
      router.replace({
        name: name,
      })
    },
  })
}

export const settingViewRoute = (rootName?: string): RouteRecordRaw[] => {
  return showSettingRoutes.map((route) => {
    return {
      name: getName(route.name, rootName),
      path: `setting/${route.name}`,
      component: () =>
        import(`../../views/dashboard/show_settings/${route.name}.vue`),
    }
  })
}

const getName = (defaultName: string, rootName?: string) => {
  return rootName ? rootName + '_' + defaultName : defaultName
}
